const editRequestDialog = {
  title: "Breyta gagnabeiðni",
  fields: {
    title: "Titill *",
    description: "Lýsing *",
    requestedFields: "Umbeðnir dálkar *",
  },
  errors: {
    noFields: "Tilgreindu að minnsta kosti einn umbeðinn dálk",
    updateFailed: "Ekki tókst að uppfæra beiðni",
  },
  actions: {
    cancel: "Hætta við",
    saving: "Vistar...",
    saveChanges: "Vista breytingar",
  },
};

export default editRequestDialog;
